import { tss } from 'tss-react/mui';

const useStyles = tss.create(() => ({
  caseAssetDetails: {
    height: '100%',
    '.kvResponsive': {
      width: '50%'
    }
  },
  assetNameContainer: {
    '& .MuiButtonBase-root': {
      paddingLeft: '0 !important'
    }
  }
}));

export default useStyles;
